<mat-drawer-container>

  <mat-drawer-content>
    <mat-toolbar color="accent" fxLayout="row" fxLayoutGap="15px" fxLayout.xs="column" [ngStyle.xs]="{'height': 'auto'}">


      <div class="titulo" fxFlex fxLayoutAlign="start">
        <h1 >Consulta de Editais</h1>
      </div>

      <div class="usuario" fxFlex fxLayoutAlign="end" >

      </div>

      <div class="logo" fxFlex="100px" fxLayoutAlign="end">
        <img src="{{logoInca}}" alt="INCA" height="50px">

      </div>
    </mat-toolbar>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
